import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "select"]

  connect() {
    this.update()
  }

  update() {
    const selectedGender = this.selectTarget.value
    const requiresSelection = selectedGender.length > 0 && !["Man", "Woman"].includes(selectedGender)

    this.sectionTarget.classList.toggle("hidden", !requiresSelection)
    const radioButtons = this.sectionTarget.querySelectorAll('input[type="radio"]')

    radioButtons.forEach((radio) => {
      radio.required = requiresSelection
    })

    if (!requiresSelection) {
      radioButtons.forEach((radio) => { radio.checked = false })
    }
  }
}
